/*
  #ANCHOR Imports
*/

import { oxgGenerateUniqueId } from "./generate-unique-id"
import { oxgFnByName } from "./fn-by-name"

/*
  #ANCHOR Vars
*/

window.oxgModals = null

/*
  #ANCHOR Loading Overlay
*/

export function oxgCreateLoadingOverlay(id = 'oxg-spinner-animation', iconName = 'spinner', showIcon = true, textContent = null) {
    oxgRemoveLoadingOverlay(id)
    let newAnimation = document.createElement('div')
    newAnimation.classList.add('status-overlay')
    newAnimation.setAttribute('id', id)
    newAnimation.setAttribute('aria-label', 'Loading')
    newAnimation.classList.add('visible', 'style-info')
    newAnimation.innerHTML = '<div role="presentation" class="container flex justify-center">'
        if(showIcon && typeof showIcon == 'boolean') newAnimation.innerHTML += '<span aria-hidden="true" class="icon-' + iconName + ' rotating"></span>'
        if(textContent && typeof textContent == 'string') newAnimation.innerHTML += '<span class="text-content">' + textContent + '</span>'
    newAnimation.innerHTML += '</div>'
    document.body.append(newAnimation)
}

export function oxgRemoveLoadingOverlay(id = 'oxg-spinner-animation') {
    let oldAnimation = document.getElementById(id)
    if( oldAnimation ) oldAnimation.remove()
}

/*
  #ANCHOR Create Modals Container
*/

function createModalsContainer() {
    let container = document.createElement('div')
    container.classList.add('modals-container')
    container.setAttribute('id', 'oxg-modals-container')
    container.setAttribute('aria-hidden', 'true')
    document.body.appendChild(container)
}

/*
  #ANCHOR oxgGetModalsData
*/

export function oxgGetModalsData() {
    let data = typeof window.oxgModalsData !== 'undefined' ? window.oxgModalsData : null
    if(data) {
        return data
    } else {
        console.error('window.oxgModalsData does not exist. Modals data could not be retrieved.')
        return false
    }
}

/*
  #ANCHOR oxgFetchModal
*/

export function oxgFetchModal(modalId) {
    let modalsData = oxgGetModalsData()
    if (modalsData) {
        let modal = modalsData[modalId]
        if(modal) {
            return modal
        } else{
            console.error('Modal could not be retrieved. Modals data found but given modal id is no match', modalId)
        }
    } else {
        console.error('Modal could not be retrieved. Modals data not found.')
        return null
    }
}

/*
  #ANCHOR oxgCreateNewModalEntity
*/

export function oxgCreateNewModalEntity(modalId, classes = null, callbackName = null, callbackArg = null, hiddenInfo = null, theModal = null) {
    console.log('creating new modal entity')
    console.log(theModal)
    let modal = theModal ? theModal : oxgFetchModal(modalId)
    if(!modal) { console.error('modal of ID "' + modalId + '" not found in oxgModals'); return }
    let hiddenInfoField
    if(hiddenInfo) {
        hiddenInfoField = document.createElement('input')
        hiddenInfoField.setAttribute('type', 'hidden')
        hiddenInfoField.classList.add('modal-hidden-info-field')
        hiddenInfoField.setAttribute('id', 'oxg-modal-hidden-info-' + modal['id'])
        if(typeof hiddenInfo == 'string') {
            hiddenInfoField.value = hiddenInfo
        } else {
            hiddenInfoField.value = JSON.stringify(hiddenInfo)
        }
    }
    let newModal = document.createElement('div')
    newModal.classList.add('oxg-modal')
    newModal.setAttribute('id', 'oxg-modal-' + modal['id'])
    newModal.setAttribute('data-modal-id', modal['id'])
    newModal.setAttribute('data-instance', oxgGenerateUniqueId())
    if(classes && typeof(classes) == 'string') {
        let classesArray = classes.split(" ")
        classesArray.forEach(theClass => {
            newModal.classList.add(theClass)
        })
    }
    let modalBg = document.createElement('div')
    modalBg.classList.add('modal-bg')
    modalBg.setAttribute('id', 'oxg-modal-bg-' + modal['id'])
    let abovemodalBoxContent = document.createElement('div')
    abovemodalBoxContent.classList.add('above-modal-box-content')
    let modalBoxContent = document.createElement('div')
    modalBoxContent.classList.add('modal-box-content')
    let modalBox = document.createElement('div')
    modalBox.classList.add('modal-box')
    modalBox.setAttribute('id', 'modal-box-' + modal['id'])

    newModal.appendChild(modalBg)
    hiddenInfoField ? newModal.appendChild(hiddenInfoField) : null
    modalBox.appendChild(abovemodalBoxContent)
    modalBoxContent.innerHTML = modal['markup']
    modalBox.appendChild(modalBoxContent)
    newModal.appendChild(modalBox)
    return newModal
}

export function oxgOpenModal(modal, classes = null, callbackName = null, callbackArg = null, hiddenInfo = null) {
    
    // Create Modal Entity in DOM
    let newModal = oxgCreateNewModalEntity(modal['id'], classes, callbackName, callbackArg, hiddenInfo, modal)

    // Append to Container
    let modalsContainer = oxgGetModalsContainer()
    modalsContainer.appendChild(newModal)

    // Add Close Modal Functionality
    let closeButton = document.getElementById('oxg-close-modal-button-' + modal['id'])
    closeButton.addEventListener('click', (e)=> {
        e.preventDefault()
        oxgCloseModalAnimated(modal['id'])
    })
    let modalBg = document.getElementById('oxg-modal-bg-' + modal['id'])
    modalBg.addEventListener('click', (e)=> {
        e.preventDefault()
        oxgCloseModalAnimated(modal['id'])
    })

    // Update Modals Container
    modalsContainer.classList.add('is-active')
    modalsContainer.removeAttribute('aria-hidden')
    modalsContainer.setAttribute('aria-modal', 'true')
    modalsContainer.setAttribute('role', 'dialog')

    // Dispatch Event
    let event = new Event('oxgModalsContainerOpen')
    document.dispatchEvent(event)
    event = new Event('oxgModalOpen')
    document.dispatchEvent(event)

    // Run Callback
    if(callbackName && callbackArg) {
        oxgFnByName(callbackName, callbackArg)
    } else if (callbackName) {
        oxgFnByName(callbackName)
    }
}

/*
  #ANCHOR oxgGetModalsContainer
*/

export function oxgGetModalsContainer() {
    let container = document.getElementById('oxg-modals-container')
    if(container) {
        return container
    } else {
        console.error('modals container not found')
        return false
    }
}

/*
  #ANCHOR oxgIsModalsContainerEmpty
*/

export function oxgIsModalsContainerEmpty() {
    let modalsContainer = oxgGetModalsContainer()
    let modals = modalsContainer.querySelectorAll('oxg-modals')
    if(modals.length == 0) {
        return true
    } else {
        return false
    }
}

/*
  #ANCHOR oxgIsModalsContainerVisible
*/

export function oxgIsModalsContainerVisible() {
    let modalsContainer = oxgGetModalsContainer()
    if(modalsContainer) {
        if (modalsContainer.classList.contains('is-active')) {
            return true
        } else {
            return false
        }
    }
    console.error('visibility of modals container unknown')
    return false
}

/*
  #ANCHOR oxgCloseModal
*/

export function oxgCloseModal(modalId) {
    let modalsContainer = document.getElementById('oxg-modals-container')
    let modal = document.getElementById('oxg-modal-' + modalId)
    if(!modal || !modalsContainer) return
    modal.classList.remove('closing')
    modal.remove()
    let modalClosed = new Event('oxgModalClose')
    document.dispatchEvent(modalClosed)
    if (oxgIsModalsContainerEmpty()) {
        modalsContainer.classList.remove('is-active')
        modalsContainer.removeAttribute('aria-modal')
        modalsContainer.removeAttribute('role')
        modalsContainer.setAttribute('aria-hidden', 'true')
        let event = new Event('oxgModalsContainerClose')
        document.dispatchEvent(event)
    }
}

/*
  #ANCHOR oxgCloseModalAnimated
*/

export function oxgCloseModalAnimated(modalId) {
    let modal = document.getElementById('oxg-modal-' + modalId)
    if(!modal) return
    modal.classList.add('closing')
    setTimeout(()=> {
        oxgCloseModal(modalId)
    }, 100);  
}

/*
  #ANCHOR class OxgModals
*/

class OxgModals {
    constructor(name = 'defaultName', autoInit = true) {
        this.modalButtonsExist = document.querySelector('.oxg-open-modal-button')
        if(this.modalButtonsExist) {
            this.name = name
            this.data = oxgGetModalsData()
            if(oxgGetModalsContainer()) {
                if(autoInit && this.data) this.init()
            } else {
                console.error('There are Buttons that should open modals, but the oxg modals container element is missing')
            }
        }
    }
    init() {
        let openButtons = document.querySelectorAll('.oxg-open-modal-button')
        Array.from(openButtons).forEach(button => {
            button.addEventListener('click', (e)=> {
                e.preventDefault()
                let id = button.getAttribute('data-modal-id')
                let callbackName = button.getAttribute('data-callback-modal-open')
                let callbackArg = button.getAttribute('data-callback-arg-modal-open')
                let modal = oxgFetchModal(id)
                let classes = button.getAttribute('data-modal-classes') ? button.getAttribute('data-modal-classes') : null
                if(!oxgIsModalsContainerVisible()) {
                    oxgOpenModal(modal, classes, callbackName, callbackArg)
                }
            })
        })
    }
}

/*
  #ANCHOR DOMContentLoaded
*/

document.addEventListener('DOMContentLoaded', () => {
    createModalsContainer();
    window.oxgModals = new OxgModals('oxgModals')
})